module.exports = __webpack_public_path__ + "static/media/graphql-autocomplete.f909cf15.png";